import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoahmedabadcab() {



  const cardData = {




keyword: "Pune to Ahmedabad Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Ahmedabad Cab Service for families, couples, business travelers, students, senior citizens, and groups planning a convenient long-distance journey. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way travel, round trips, corporate visits, family functions, shopping trips, educational travel, and customized Ahmedabad travel plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes travel from Pune to Ahmedabad smooth and convenient. Travelers can also customize their itinerary to explore heritage landmarks, temples, museums, riverfront attractions, markets, cultural sites, and nearby destinations around Ahmedabad according to their preferred schedule.",

topPlaces: [
  {
    title: "Sabarmati Ashram",
    description: "Sabarmati Ashram is one of Ahmedabad's most significant historical landmarks and is closely associated with Mahatma Gandhi and India's freedom movement. Visitors from Pune can explore the peaceful premises, museum, and historical exhibits while learning about India's modern history. Garud Cab Service provides convenient private transportation for travelers including the ashram in their Ahmedabad sightseeing itinerary."
  },
  {
    title: "Adalaj Stepwell",
    description: "Adalaj Stepwell is a magnificent architectural landmark near Ahmedabad known for its intricate stone carvings, underground chambers, and traditional stepwell design. It is an excellent destination for history and architecture enthusiasts traveling from Pune. Customers can book a private cab and conveniently include Adalaj along with other heritage attractions in their itinerary."
  },
  {
    title: "Kankaria Lake",
    description: "Kankaria Lake is a popular recreational destination in Ahmedabad surrounded by gardens, leisure attractions, walking areas, and family entertainment options. It is suitable for visitors of different age groups and is especially popular during evening hours. Garud Cab Service can arrange comfortable city transportation for travelers exploring Kankaria and nearby attractions."
  },
  {
    title: "Sabarmati Riverfront",
    description: "Sabarmati Riverfront is one of Ahmedabad's prominent urban attractions, offering landscaped promenades, open spaces, recreational areas, and views along the Sabarmati River. Travelers can enjoy a relaxed evening while exploring the city. Customers traveling from Pune can include the riverfront in a customized sightseeing itinerary with convenient private cab transportation."
  },
  {
    title: "Akshardham Temple",
    description: "Akshardham Temple in Gandhinagar is a major spiritual and cultural attraction located close to Ahmedabad and is known for its impressive architecture and peaceful surroundings. Families and devotees often include the temple in their Gujarat travel plans. Garud Cab Service provides comfortable chauffeur-driven transportation from Pune with flexible arrangements for Ahmedabad and Gandhinagar sightseeing."
  },
  {
    title: "Sidi Saiyyed Mosque",
    description: "Sidi Saiyyed Mosque is a famous historic monument in Ahmedabad recognized for its detailed stone latticework, particularly the celebrated Tree of Life carving. It represents the city's rich architectural heritage and is popular among history and photography enthusiasts. Customers can conveniently visit the mosque as part of a private Ahmedabad city tour."
  },
  {
    title: "Science City Ahmedabad",
    description: "Science City Ahmedabad is a popular educational and recreational destination featuring interactive exhibits, scientific displays, and attractions designed for students, families, and curious travelers. It is suitable for educational outings and family sightseeing. Travelers from Pune can book a comfortable private cab to explore Science City along with other Ahmedabad attractions."
  },
  {
    title: "Modhera Sun Temple",
    description: "The Modhera Sun Temple is a renowned heritage monument in Gujarat known for its detailed carvings, architectural design, and historic association with Sun worship. It is an excellent addition to a longer Gujarat sightseeing itinerary from Pune. Customers can customize their cab journey to include Modhera along with Ahmedabad and other nearby destinations."
  },
  {
    title: "Gandhinagar",
    description: "Gandhinagar is the capital of Gujarat and is located close to Ahmedabad, offering attractions such as Akshardham Temple, parks, government landmarks, and planned urban spaces. Travelers from Pune can conveniently combine Ahmedabad and Gandhinagar in one road trip. Garud Cab Service provides private chauffeur-driven vehicles with flexible multi-destination travel options."
  },
  {
    title: "Law Garden",
    description: "Law Garden is a popular Ahmedabad destination known for its open recreational area, local shopping, handicrafts, traditional Gujarati products, and evening street-food atmosphere. Travelers can experience local culture and shop for regional items during their city visit. Customers can comfortably reach Law Garden by private cab and include it in a customized Ahmedabad sightseeing plan."
  }
],




"services": [
{
"name": "Pune to Vapi Cab Service",
"description": "Book Pune to Vapi Cab Service for comfortable and convenient intercity transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for business travelers, families, tourists, and individuals looking for private travel from Pune to Vapi."
},
{
"name": "Pune to Ahmedabad Cab",
"description": "Choose Pune to Ahmedabad Cab for comfortable long-distance transportation with convenient pickup from Pune and direct destination drop. Sedan, SUV, Innova, and premium vehicles can be arranged according to passenger count, luggage, and travel preferences."
},
{
"name": "Pune to Ahmedabad Cab Price",
"description": "Check Pune to Ahmedabad Cab Price according to the selected vehicle category, pickup location, travel schedule, and journey requirements. Customers can choose practical sedan, spacious SUV, Innova, or premium cab options for private intercity travel."
},
{
"name": "Pune to Ahmedabad Car Rental",
"description": "Book Pune to Ahmedabad Car Rental for chauffeur-driven private transportation between Pune and Ahmedabad. Comfortable AC vehicles can be arranged for families, corporate travelers, tourists, personal visits, and long-distance journeys according to travel requirements."
},
{
"name": "Pune to Ahmedabad Taxi",
"description": "Choose Pune to Ahmedabad Taxi for convenient point-to-point transportation with experienced chauffeurs and comfortable vehicles. The service is suitable for business trips, family journeys, sightseeing, personal travel, and passengers requiring private long-distance transportation."
},
{
"name": "Pune to Ahmedabad Taxi Fare",
"description": "Find Pune to Ahmedabad Taxi Fare based on the vehicle type, pickup location, journey plan, and travel requirements. Sedan, SUV, Innova, and premium taxi options can be selected for comfortable and convenient intercity travel."
},
{
"name": "Cab from Pune to Ahmedabad",
"description": "Reserve a Cab from Pune to Ahmedabad for direct private transportation with flexible pickup arrangements from Pune. The service is suitable for individuals, families, corporate passengers, tourists, and travelers planning a comfortable road journey to Ahmedabad."
},
{
"name": "Pune to Vapi Cab",
"description": "Book Pune to Vapi Cab for convenient private transportation between Pune and Vapi with professional chauffeur service. Comfortable AC cars can be arranged for families, business travelers, tourists, and individuals traveling for personal or professional requirements."
},
{
"name": "Pune to Vapi Taxi",
"description": "Choose Pune to Vapi Taxi for a comfortable intercity journey with flexible pickup options and experienced drivers. Sedan, SUV, Innova, and premium vehicle categories can be selected according to passenger requirements, luggage, and travel preferences."
},
{
"name": "Cab from Pune to Vapi",
"description": "Reserve a Cab from Pune to Vapi for direct point-to-point transportation with convenient pickup from your preferred Pune location. The service is suitable for corporate travelers, families, tourists, and passengers looking for comfortable long-distance travel."
},
{
"name": "Taxi from Pune to Vapi",
"description": "Book a Taxi from Pune to Vapi for private chauffeur-driven transportation with comfortable AC interiors. The service is suitable for business visits, family trips, tourism, personal travel, and passengers requiring scheduled intercity transportation."
},
{
"name": "Pune to Vapi Taxi Fare",
"description": "Check Pune to Vapi Taxi Fare according to the selected vehicle, pickup location, journey type, and travel requirements. Sedan, SUV, Innova, and premium options can be arranged for comfortable private transportation."
},
{
"name": "Pune to Vapi One Way Cab",
"description": "Choose Pune to Vapi One Way Cab for convenient point-to-point transportation without requiring a return booking. The service is suitable for relocation, business travel, family visits, personal journeys, and passengers traveling to Vapi for a one-way trip."
},
{
"name": "Pune to Vapi Round Trip Taxi",
"description": "Book Pune to Vapi Round Trip Taxi for planned travel with return transportation included in the journey. The service is suitable for business visits, family trips, personal work, sightseeing, and passengers requiring convenient return travel."
},
{
"name": "Pune to Vapi Cab Booking",
"description": "Make Pune to Vapi Cab Booking for scheduled private transportation with convenient vehicle selection and pickup arrangements. Sedan, SUV, Innova, and premium cars can be selected according to passenger count, luggage, travel timing, and comfort requirements."
},
{
"name": "Cheap Pune to Vapi Cab",
"description": "Book a Cheap Pune to Vapi Cab for economical private transportation with practical vehicle choices. The service is suitable for individuals, families, students, business travelers, and budget-conscious passengers looking for comfortable long-distance travel."
},
{
"name": "Best Pune to Vapi Taxi",
"description": "Choose the Best Pune to Vapi Taxi for comfortable intercity transportation supported by professional chauffeurs and well-maintained vehicles. The service is suitable for families, corporate travelers, tourists, and individuals planning a private road journey."
},
{
"name": "Sedan Pune to Vapi Cab",
"description": "Book Sedan Pune to Vapi Cab for comfortable AC transportation suitable for individuals, couples, and small families. Sedan vehicles provide practical seating and luggage space for business travel, personal visits, and long-distance journeys."
},
{
"name": "SUV Pune to Vapi Taxi",
"description": "Choose SUV Pune to Vapi Taxi for spacious and comfortable transportation with additional seating and luggage capacity. The vehicle is suitable for families, groups, corporate passengers, tourists, and travelers planning a longer road trip."
},
{
"name": "Innova Pune to Vapi Cab",
"description": "Book Innova Pune to Vapi Cab for spacious chauffeur-driven travel suitable for families and small groups. The vehicle offers comfortable seating and practical luggage capacity for business journeys, family trips, sightseeing, and personal travel."
},
{
"name": "Highway Cab Pune Vapi",
"description": "Choose Highway Cab Pune Vapi for comfortable private transportation along the long-distance route between Pune and Vapi. Professional chauffeurs and well-maintained AC vehicles make the service suitable for families, corporate travelers, tourists, and personal journeys."
},
{
"name": "Pune to Anand Cab Service",
"description": "Book Pune to Anand Cab Service for convenient private transportation between Pune and Anand. Comfortable chauffeur-driven vehicles are suitable for business travelers, families, tourists, personal visits, and passengers requiring direct long-distance travel."
},
{
"name": "Pune to Somnath Cab",
"description": "Choose Pune to Somnath Cab for comfortable long-distance travel to Somnath with convenient private transportation. The service is suitable for devotees, families, tourists, and groups planning a pilgrimage or sightseeing journey with professional chauffeur assistance."
},
{
"name": "Pune to Somnath Cab Service",
"description": "Book Pune to Somnath Cab Service for private chauffeur-driven transportation from Pune to Somnath. Comfortable AC vehicles can be arranged for devotees, families, tourists, and groups planning a religious or sightseeing trip to Gujarat."
},
{
"name": "Pune to Somnath Taxi Service",
"description": "Choose Pune to Somnath Taxi Service for a comfortable and convenient long-distance pilgrimage journey. Sedan, SUV, Innova, and larger vehicles can be selected according to passenger count, luggage, and travel requirements."
},
{
"name": "Somnath Darshan Cab from Pune",
"description": "Book Somnath Darshan Cab from Pune for private transportation planned around a visit to Somnath Temple. The service is suitable for devotees, families, senior passengers, and groups looking for comfortable road travel with flexible journey arrangements."
},
{
"name": "Pune to Somnath Jyotirlinga Cab",
"description": "Choose Pune to Somnath Jyotirlinga Cab for comfortable private transportation to one of the revered Jyotirlinga pilgrimage destinations. The service is suitable for devotees, families, and groups planning a dedicated religious journey from Pune."
},
{
"name": "Pune to Bhavnagar Cab Service",
"description": "Book Pune to Bhavnagar Cab Service for reliable intercity transportation with comfortable AC vehicles and professional chauffeurs. The service is suitable for corporate travel, family journeys, tourism, personal visits, and long-distance transportation requirements."
},
{
"name": "Pune to Bhavnagar Taxi Service",
"description": "Choose Pune to Bhavnagar Taxi Service for convenient point-to-point transportation between Pune and Bhavnagar. Sedan, SUV, Innova, and premium vehicle options can be arranged according to passenger requirements and luggage capacity."
},
{
"name": "Pune to Bhavnagar Cab Booking",
"description": "Make Pune to Bhavnagar Cab Booking for scheduled private travel with convenient pickup and vehicle selection. Customers can arrange suitable chauffeur-driven cars according to their travel date, passenger count, luggage, and preferred comfort level."
},
{
"name": "Best Pune to Bhavnagar Cab",
"description": "Choose the Best Pune to Bhavnagar Cab for comfortable long-distance transportation with professional chauffeur assistance and well-maintained vehicles. The service is suitable for families, corporate travelers, tourists, and individuals planning private intercity travel."
},
{
"name": "One Way Pune to Bhavnagar Cab",
"description": "Book One Way Pune to Bhavnagar Cab for direct transportation without the need to reserve a return journey. The service is suitable for relocation, business travel, family visits, personal trips, and passengers traveling to Bhavnagar for a one-way journey."
},
{
"name": "Round Trip Pune to Bhavnagar Cab",
"description": "Choose Round Trip Pune to Bhavnagar Cab for convenient travel with planned return transportation. The service is suitable for business visits, family journeys, sightseeing, personal work, and travelers who need a scheduled return trip."
},
{
"name": "Pune to Junagadh Cabs",
"description": "Book Pune to Junagadh Cabs for comfortable private transportation from Pune to Junagadh. Sedan, SUV, Innova, and larger vehicle options can be arranged for families, tourists, business travelers, and groups planning long-distance travel."
},
{
"name": "Pune to Junagadh Cab Service",
"description": "Choose Pune to Junagadh Cab Service for convenient chauffeur-driven transportation between Pune and Junagadh. The service is suitable for tourism, family travel, business visits, religious journeys, and personal transportation requirements."
},
{
"name": "Pune to Junagadh Taxi Service",
"description": "Book Pune to Junagadh Taxi Service for comfortable intercity transportation with professional drivers and well-maintained AC vehicles. Customers can select suitable car categories based on passenger count, luggage, and travel preferences."
},
{
"name": "Pune to Junagadh Cab Booking",
"description": "Reserve Pune to Junagadh Cab Booking for advance private transportation with convenient pickup arrangements. Sedan, SUV, Innova, and premium vehicles can be arranged according to travel timing, passenger requirements, and journey preferences."
},
{
"name": "Pune to Gandhinagar Cabs",
"description": "Book Pune to Gandhinagar Cabs for comfortable long-distance transportation with private chauffeur assistance. The service is suitable for corporate travelers, families, tourists, government-related visits, personal travel, and passengers requiring direct intercity transportation."
},
{
"name": "Pune to Gandhinagar Cab Service",
"description": "Choose Pune to Gandhinagar Cab Service for convenient private transportation between Pune and Gandhinagar. Comfortable AC vehicles and professional chauffeurs make the service suitable for business trips, family journeys, tourism, and personal visits."
},
{
"name": "Pune to Gandhinagar Taxi Service",
"description": "Book Pune to Gandhinagar Taxi Service for reliable chauffeur-driven travel with flexible pickup arrangements. Sedan, SUV, Innova, and premium vehicles can be selected according to passenger count, luggage, and travel requirements."
},
{
"name": "Pune to Gandhinagar Cab Booking",
"description": "Make Pune to Gandhinagar Cab Booking for scheduled private transportation with convenient vehicle selection. The service is suitable for corporate passengers, families, tourists, and individuals planning a comfortable long-distance journey."
},
{
"name": "Best Pune to Gandhinagar Cab",
"description": "Choose the Best Pune to Gandhinagar Cab for comfortable intercity travel supported by professional chauffeurs and well-maintained vehicles. The service is suitable for business travelers, families, tourists, and passengers seeking reliable private transportation."
},
{
"name": "Pune to Jamnagar Taxi Service",
"description": "Book Pune to Jamnagar Taxi Service for comfortable long-distance transportation with professional chauffeur assistance. The service is suitable for families, corporate travelers, tourists, personal visits, and passengers planning a private road journey to Jamnagar."
},
{
"name": "Pune to Jamnagar Cab Booking",
"description": "Choose Pune to Jamnagar Cab Booking for advance private transportation with flexible pickup and vehicle selection. Sedan, SUV, Innova, and premium cars can be arranged according to passenger count, luggage, travel timing, and comfort requirements."
},
{
"name": "Best Pune to Jamnagar Cab",
"description": "Book the Best Pune to Jamnagar Cab for convenient long-distance travel with professional chauffeurs and comfortable AC vehicles. The service is suitable for families, business travelers, tourists, groups, and individuals planning private intercity transportation."
},
{
"name": "One Way Pune to Jamnagar Cab",
"description": "Choose One Way Pune to Jamnagar Cab for direct point-to-point travel without requiring a return booking. The service is suitable for relocation, business travel, family visits, personal journeys, and passengers traveling to Jamnagar for a one-way trip."
},
{
"name": "Round Trip Pune to Jamnagar Taxi",
"description": "Book Round Trip Pune to Jamnagar Taxi for convenient transportation with return travel included in the journey plan. It is suitable for business meetings, family visits, tourism, personal work, and travelers requiring scheduled return transportation."
}
],
"tableData": [
["Pune to Vapi Cab Service", "Pune to Ahmedabad Cab"],
["Pune to Ahmedabad Cab Price", "Pune to Ahmedabad Car Rental"],
["Pune to Ahmedabad Taxi", "Pune to Ahmedabad Taxi Fare"],
["Cab from Pune to Ahmedabad", "Pune to Vapi Cab"],
["Pune to Vapi Taxi", "Cab from Pune to Vapi"],
["Taxi from Pune to Vapi", "Pune to Vapi Taxi Fare"],
["Pune to Vapi One Way Cab", "Pune to Vapi Round Trip Taxi"],
["Pune to Vapi Cab Booking", "Cheap Pune to Vapi Cab"],
["Best Pune to Vapi Taxi", "Sedan Pune to Vapi Cab"],
["SUV Pune to Vapi Taxi", "Innova Pune to Vapi Cab"],
["Highway Cab Pune Vapi", "Pune to Anand Cab Service"],
["Pune to Somnath Cab", "Pune to Somnath Cab Service"],
["Pune to Somnath Taxi Service", "Somnath Darshan Cab from Pune"],
["Pune to Somnath Jyotirlinga Cab", "Pune to Bhavnagar Cab Service"],
["Pune to Bhavnagar Taxi Service", "Pune to Bhavnagar Cab Booking"],
["Best Pune to Bhavnagar Cab", "One Way Pune to Bhavnagar Cab"],
["Round Trip Pune to Bhavnagar Cab", "Pune to Junagadh Cabs"],
["Pune to Junagadh Cab Service", "Pune to Junagadh Taxi Service"],
["Pune to Junagadh Cab Booking", "Pune to Gandhinagar Cabs"],
["Pune to Gandhinagar Cab Service", "Pune to Gandhinagar Taxi Service"],
["Pune to Gandhinagar Cab Booking", "Best Pune to Gandhinagar Cab"],
["Pune to Jamnagar Taxi Service", "Pune to Jamnagar Cab Booking"],
["Best Pune to Jamnagar Cab", "One Way Pune to Jamnagar Cab"],
["Round Trip Pune to Jamnagar Taxi", "Pune to Vapi Cab Service"]
]
,



whychoose: [
  {
    WhyChooseheading: "Pune to Ahmedabad Cab for Convenient Long-Distance Travel",
    WhyChoosedescription: "A private cab provides a practical travel option between Pune and Ahmedabad for families, professionals, students, couples, and groups who prefer a direct road journey planned around their schedule."
  },
  {
    WhyChooseheading: "Door-to-Door Pickup & Drop",
    WhyChoosedescription: "Your journey can begin from a preferred home, hotel, office, residential area, or other accessible point in Pune and continue directly to your selected destination in Ahmedabad."
  },
  {
    WhyChooseheading: "Comfortable Choice for Families & Groups",
    WhyChoosedescription: "Families and groups can select a suitable vehicle according to passenger numbers, luggage requirements, and comfort preferences, allowing everyone to travel together throughout the journey."
  },
  {
    WhyChooseheading: "Convenient for Business & Corporate Travel",
    WhyChoosedescription: "Professionals travelling to Ahmedabad for meetings, client visits, office assignments, industrial work, conferences, or project requirements can arrange private transportation around their work schedule."
  },
  {
    WhyChooseheading: "One-Way Cab for Direct Transportation",
    WhyChoosedescription: "Passengers heading to Ahmedabad for relocation, education, personal work, family visits, or professional commitments can choose a one-way cab without requiring the same vehicle for their return."
  },
  {
    WhyChooseheading: "Round-Trip Cab for Planned Visits",
    WhyChoosedescription: "When a return journey to Pune is required, a round-trip cab can be planned according to your Ahmedabad visit, business appointment, family event, sightseeing schedule, or preferred return date."
  },
  {
    WhyChooseheading: "Suitable for Personal & Family Occasions",
    WhyChoosedescription: "Private road transportation can be arranged for weddings, family gatherings, social occasions, personal visits, educational travel, and other planned journeys between Pune and Ahmedabad."
  },
  {
    WhyChooseheading: "Simple Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Pune pickup location, Ahmedabad destination, travel date, passenger count, luggage details, preferred vehicle, and trip type with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Ahmedabad Cab Service?",
    answer: "Yes, Garud Cab Service provides private Pune to Ahmedabad cab services for families, professionals, students, couples, groups, business travel, personal visits, and other long-distance transportation requirements."
  },
  {
    question: "Can I book a one-way cab from Pune to Ahmedabad?",
    answer: "Yes, one-way cab service can be arranged for passengers who need direct transportation from Pune to their preferred destination in Ahmedabad."
  },
  {
    question: "Can I reserve a round-trip Pune to Ahmedabad cab?",
    answer: "Yes, round-trip cab arrangements can be planned according to your Ahmedabad visit, business schedule, family plans, sightseeing itinerary, or preferred return date."
  },
  {
    question: "Is Pune to Ahmedabad cab suitable for families?",
    answer: "Yes, private cab travel is suitable for families and groups who want to stay together throughout the journey with convenient seating and luggage arrangements."
  },
  {
    question: "Can I use the cab for business travel to Ahmedabad?",
    answer: "Yes, the cab can be used for client meetings, office assignments, industrial visits, conferences, project work, professional appointments, and other business-related journeys."
  },
  {
    question: "Can I book a cab for a family function in Ahmedabad?",
    answer: "Yes, private transportation can be arranged for weddings, family functions, social events, personal visits, and other planned occasions in Ahmedabad."
  },
  {
    question: "Can I book a cab for relocation from Pune to Ahmedabad?",
    answer: "Yes, a private cab can be considered for relocation or personal shifting requirements depending on the passenger and luggage capacity of the selected vehicle."
  },
  {
    question: "Can I get pickup from my home or office in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred location in Pune."
  },
  {
    question: "Can I carry luggage in the Pune to Ahmedabad cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger luggage requirements should be communicated while making the booking."
  },
  {
    question: "How can I book a Pune to Ahmedabad Cab?",
    answer: "Share your Pune pickup location, Ahmedabad destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Dhruv Mehta",
    feedback: "We travelled from Pune to Ahmedabad for a family event and chose a private cab. Having one vehicle for the entire family made the long journey convenient, especially with our luggage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Shah",
    feedback: "I needed to travel from Pune to Ahmedabad for professional work and preferred a direct cab. The private journey gave me more flexibility while planning around my work schedule.",
    rating: 5
  }
];
















  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ahmedabad Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-ahmedabad-cab.webp",
  "description": "Book Pune to Ahmedabad Cab with Garud Cab for safe, comfortable, and reliable long-distance travel. Get Pune to Ahmedabad cab, taxi, car rental, and outstation travel services for one way and round trip journeys. Cab services to Vapi are also available with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for business trips, family travel, and intercity transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-ahmedabad-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune to Ahmedabad Cab | Taxi & Car Rental Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Ahmedabad Cab with Garud Cab for comfortable and reliable long-distance travel. Get one way, round trip, taxi, car rental, and Vapi cab services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Pune to Vapi Cab Service, Pune to Ahmedabad Cab, Pune to Ahmedabad Cab Price, Pune to Ahmedabad Car Rental, Pune to Ahmedabad Taxi, Pune to Ahmedabad Taxi Fare, Cab from Pune to Ahmedabad, Pune to Vapi Cab, Pune to Vapi Taxi, Pune to Ahmedabad One Way Cab, Pune to Ahmedabad Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/117.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoahmedabadcab;